import { useState, useEffect } from 'react';
import '../styles/Dice.css';

function Dice({ die, isSelected, onSelect, isRolling }) {
  const [displayValue, setDisplayValue] = useState(die.value);

  // Animate through faces while rolling
  useEffect(() => {
    if (!isRolling) {
      setDisplayValue(die.value);
      return;
    }

    const rollSequence = [1, 6, 2, 4, 3, 5, 1, 6, 2, 4, 3, 5, 1, 2, die.value];
    let stepIndex = 0;

    const interval = setInterval(() => {
      if (stepIndex < rollSequence.length) {
        setDisplayValue(rollSequence[stepIndex]);
        stepIndex++;
      }
    }, 60); // 60ms per face

    return () => clearInterval(interval);
  }, [isRolling, die.value]);

  // ...existing code...

  // Map die values to rotations for 3D cube
  const rotationMap = {
    1: { x: 0, y: 0 },
    2: { x: 0, y: -90 },
    3: { x: 0, y: 90 },
    4: { x: 0, y: 180 },
    5: { x: -90, y: 0 },
    6: { x: 90, y: 0 }
  };

  // Show animated value while rolling, then final value
  const rotation = rotationMap[displayValue] || { x: 0, y: 0 };

  // Determine dot color - black for white/light dice, white for dark dice
  const dotColor = die.color === '#FFFFFF' ? '#000000' : '#FFFFFF';

  return (
    <div
      className={`dice-container ${isSelected ? 'selected' : ''}`}
      onClick={onSelect}
    >
      <div
        className="dice"
        style={{
          transform: `rotateX(${rotation.x}deg) rotateY(${rotation.y}deg)`
        }}
      >
        {/* Face 1 - 1 dot */}
        <div className="dice-face front" style={{ backgroundColor: die.color }}>
          <div className="dots-container">
            <div className="dot" style={{ backgroundColor: dotColor }}></div>
          </div>
        </div>

        {/* Face 2 - 2 dots */}
        <div className="dice-face right" style={{ backgroundColor: die.color }}>
          <div className="dots-container two-dots">
            <div className="dot" style={{ backgroundColor: dotColor }}></div>
            <div className="dot" style={{ backgroundColor: dotColor }}></div>
          </div>
        </div>

        {/* Face 3 - 3 dots */}
        <div className="dice-face left" style={{ backgroundColor: die.color }}>
          <div className="dots-container three-dots">
            <div className="dot" style={{ backgroundColor: dotColor }}></div>
            <div className="dot" style={{ backgroundColor: dotColor }}></div>
            <div className="dot" style={{ backgroundColor: dotColor }}></div>
          </div>
        </div>

        {/* Face 4 - 4 dots */}
        <div className="dice-face back" style={{ backgroundColor: die.color }}>
          <div className="dots-container four-dots">
            <div className="dot" style={{ backgroundColor: dotColor }}></div>
            <div className="dot" style={{ backgroundColor: dotColor }}></div>
            <div className="dot" style={{ backgroundColor: dotColor }}></div>
            <div className="dot" style={{ backgroundColor: dotColor }}></div>
          </div>
        </div>

        {/* Face 5 - 5 dots */}
        <div className="dice-face top" style={{ backgroundColor: die.color }}>
          <div className="dots-container five-dots">
            <div className="dot" style={{ backgroundColor: dotColor }}></div>
            <div className="dot" style={{ backgroundColor: dotColor }}></div>
            <div className="dot" style={{ backgroundColor: dotColor }}></div>
            <div className="dot" style={{ backgroundColor: dotColor }}></div>
            <div className="dot" style={{ backgroundColor: dotColor }}></div>
          </div>
        </div>

        {/* Face 6 - 6 dots */}
        <div className="dice-face bottom" style={{ backgroundColor: die.color }}>
          <div className="dots-container six-dots">
            <div className="dot" style={{ backgroundColor: dotColor }}></div>
            <div className="dot" style={{ backgroundColor: dotColor }}></div>
            <div className="dot" style={{ backgroundColor: dotColor }}></div>
            <div className="dot" style={{ backgroundColor: dotColor }}></div>
            <div className="dot" style={{ backgroundColor: dotColor }}></div>
            <div className="dot" style={{ backgroundColor: dotColor }}></div>
          </div>
        </div>
      </div>
      <div className="dice-label">{die.colorName} <span className="dice-value">{die.value}</span></div>
    </div>
  );
}

export default Dice;

